import { EventSourceType } from '../../domain/Calendar/CalendarEvent';
import { useUserPermissions } from '../../context/user/PermissionsProvider';

export const useEventSource = (): EventSourceType => {
  const { isSupportUser } = useUserPermissions();

  return isSupportUser ? EventSourceType.Support : EventSourceType.Store;
};
